import { Helmet } from "react-helmet-async";
import PageLayout from "@/components/layout/PageLayout";

const Privacy = () => {
  return (
    <PageLayout>
      <Helmet>
        <title>Datenschutzerklärung – NextInvoice</title>
        <meta name="description" content="Datenschutzerklärung von NextInvoice. Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://nxtinvoice.de/datenschutz" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Startseite", "item": "https://nxtinvoice.de/" },
            { "@type": "ListItem", "position": 2, "name": "Datenschutz" }
          ]
        })}</script>
      </Helmet>
      <section className="bg-background py-20 lg:py-28">
        <div className="container">
          <div className="mx-auto max-w-3xl">
            <h1 className="mb-2 font-display text-4xl font-bold text-foreground">Datenschutzerklärung</h1>
            <p className="mb-10 text-sm text-muted-foreground">Stand: 23.03.2026</p>

            <div className="space-y-10 text-muted-foreground leading-relaxed">

              {/* 1 */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">1. Verantwortlicher</h2>
                <p>Verantwortlicher im Sinne der DSGVO ist:</p>
                <p className="mt-2">
                  <strong>Lizenzwerk24, Inhaber: Dustin Lailach</strong><br />
                  Hauptstraße 56<br />
                  02727 Neugersdorf<br />
                  Deutschland<br />
                  E-Mail: <a href="mailto:legal@nxtinvoice.de" className="text-primary hover:underline">legal@nxtinvoice.de</a><br />
                  Telefon: +49 15565 350880
                </p>
                <p className="mt-2">
                  Ein Datenschutzbeauftragter ist nicht benannt, da die gesetzlichen Voraussetzungen nach Art. 37 DSGVO i.V.m. § 38 BDSG nicht erfüllt sind.
                </p>
              </div>

              {/* 2 */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">2. Allgemeines zur Datenverarbeitung</h2>
                <p>
                  Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung unserer Dienste, zur Erfüllung vertraglicher Pflichten, zur Wahrung berechtigter Interessen oder auf Grundlage einer Einwilligung erforderlich ist.
                </p>
                <p className="mt-2">
                  Personenbezogene Daten werden gelöscht, sobald der Verarbeitungszweck entfällt und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
                </p>
              </div>

              {/* 3 */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">3. Hosting und Infrastruktur</h2>

                <h3 className="mt-4 mb-2 font-semibold text-foreground">3.1 Website-Hosting (Lovable)</h3>
                <p>
                  Die Website nxtinvoice.de wird über <strong>Lovable Technology Ltd.</strong> (lovable.dev) gehostet. Beim Aufruf der Website verarbeitet der Server automatisch technische Zugriffsdaten (z.B. IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seite, Browser- und Betriebssystemtyp). Diese Daten dienen ausschließlich dem sicheren und stabilen Betrieb der Website.
                </p>
                <p className="mt-2">
                  Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse). Mit Lovable besteht ein Auftragsverarbeitungsvertrag nach Art. 28 DSGVO. Soweit Server außerhalb der EU/des EWR betrieben werden, erfolgt die Übermittlung auf Basis von Standardvertragsklauseln (Art. 46 DSGVO).
                </p>

                <h3 className="mt-4 mb-2 font-semibold text-foreground">3.2 Backend und Datenbank (Supabase)</h3>
                <p>
                  Für die Datenhaltung und Nutzerauthentifizierung setzen wir <strong>Supabase Inc.</strong> ein (Sub-Auftragsverarbeiter im Rahmen der Lovable-Infrastruktur). Supabase verarbeitet die zur Bereitstellung des Dienstes erforderlichen Nutzerdaten (Anmeldedaten, Profil- und Vertragsdaten). Wir konfigurieren Supabase so, dass eine EU-basierte Datenhaltung angestrebt wird; auf etwaige Drittlandübermittlungen wird in Abschnitt 9 hingewiesen.
                </p>
                <p className="mt-2">Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).</p>

                <h3 className="mt-4 mb-2 font-semibold text-foreground">3.3 Domain- und E-Mail-Hosting (STRATO)</h3>
                <p>
                  Domain und E-Mail-Dienste werden über die <strong>STRATO AG</strong>, Pascalstraße 10, 10587 Berlin, bereitgestellt. STRATO verarbeitet dabei technische Verbindungs- und Logdaten.
                </p>
                <p className="mt-2">Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO. Mit STRATO besteht ein Auftragsverarbeitungsvertrag nach Art. 28 DSGVO.</p>
              </div>

              {/* 4 */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">4. Benutzerkonto und Authentifizierung</h2>
                <p>Für die Nutzung von nxtinvoice.de ist ein Benutzerkonto erforderlich. Die Authentifizierung erfolgt über Supabase Auth.</p>
                <p className="mt-2"><strong>Verarbeitete Datenkategorien:</strong></p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>E-Mail-Adresse und Passwort (verschlüsselt gespeichert) — für Registrierung und Login</li>
                  <li>Optionale Profildaten (Vorname, Nachname, Firmenname)</li>
                  <li>Sitzungsdaten (Authentifizierungs-Token, der zur Aufrechterhaltung der Anmeldung im lokalen Browserspeicher abgelegt wird)</li>
                </ul>
                <p className="mt-2">Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).</p>
                <p className="mt-2">
                  Die Angabe einer gültigen E-Mail-Adresse ist für die Kontoerstellung und damit für die Nutzung des Dienstes zwingend erforderlich. Ohne diese Angabe kann kein Nutzungsverhältnis begründet werden. Die Angabe von Vor- und Nachname sowie Firmenname ist freiwillig.
                </p>
                <p className="mt-2">
                  Im Rahmen der Registrierung wird eine E-Mail-Verifizierung durchgeführt; bei Bedarf kann ein Passwort-Reset per E-Mail angefordert werden. Zur Kontosicherheit werden eingegebene Passwörter gegen bekannte Datenleck-Datenbanken geprüft.
                </p>
              </div>

              {/* 5 */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">5. Vertragsabwicklung und Abonnementverwaltung</h2>
                <p>Im Rahmen der Nutzung unserer Dienste verarbeiten wir folgende Datenkategorien:</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Profil- und Kontaktdaten (Name, E-Mail-Adresse, ggf. Firmenname)</li>
                  <li>Vertragsdaten (gewählter Tarif, gebuchte Funktionen, Abonnementstatus)</li>
                  <li>Abrechnungsrelevante Daten (Zahlungsstatus, Rechnungszuordnung — vollständige Zahlungsdaten werden ausschließlich durch Stripe verarbeitet, siehe Abschnitt 6)</li>
                </ul>
                <p className="mt-2">
                  Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung), soweit gesetzliche Aufbewahrungspflichten betroffen sind zusätzlich Art. 6 Abs. 1 lit. c DSGVO.
                </p>
              </div>

              {/* 6 */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">6. Zahlungsabwicklung (Stripe)</h2>
                <p>Für die Zahlungsabwicklung setzen wir <strong>Stripe</strong> ein.</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>EU-Dienstleister: Stripe Payments Europe Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland</li>
                  <li>US-Muttergesellschaft: Stripe, Inc., 354 Oyster Point Blvd, South San Francisco, CA 94080, USA</li>
                </ul>
                <p className="mt-2">
                  Stripe verarbeitet Name, E-Mail-Adresse, Zahlungsmittelinformationen, Rechnungsadresse sowie technische Daten zur Betrugsprävention. Wir erhalten von Stripe ausschließlich Informationen, die zur Zuordnung von Zahlungen und Abonnements notwendig sind (z.B. Zahlungsstatus, Kunden-ID).
                </p>
                <p className="mt-2">
                  Über einen Link können Nutzer auf das <strong>Stripe-Kundenportal</strong> (billing.stripe.com) weitergeleitet werden, um Zahlungsmethoden und Abonnements selbst zu verwalten; es gelten die Datenschutzbestimmungen von Stripe.
                </p>
                <p className="mt-2">
                  Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO. Mit Stripe besteht ein Data Processing Agreement (DPA) nach Art. 28 DSGVO. Für Übermittlungen in die USA werden Standardvertragsklauseln eingesetzt.
                  Weitere Informationen:{" "}
                  <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                    stripe.com/de/privacy
                  </a>
                </p>
                <p className="mt-2">Während der kostenlosen Testphase (30 Tage) werden keine Zahlungsdaten erhoben.</p>
              </div>

              {/* 7 — Webanalyse und Marketing */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">7. Webanalyse und Marketing</h2>
                <p>
                  Wir setzen Analyse- und Marketing-Werkzeuge nur ein, wenn Sie über unseren Cookie-Banner ausdrücklich zugestimmt haben (Opt-in). Ohne Ihre Einwilligung werden keine entsprechenden Cookies gesetzt und keine Daten an Dritte übermittelt.
                </p>

                <h3 className="mt-4 mb-2 font-semibold text-foreground">7.1 Google Tag Manager (GTM)</h3>
                <p>
                  Wir verwenden den Google Tag Manager der <strong>Google Ireland Limited</strong>, Gordon House, Barrow Street, Dublin 4, Irland, zur zentralen Verwaltung von Website-Tags. Der GTM selbst erhebt keine personenbezogenen Daten und setzt keine eigenen Cookies. Er steuert lediglich die Auslösung der nachfolgend beschriebenen Dienste.
                </p>

                <h3 className="mt-4 mb-2 font-semibold text-foreground">7.2 Google Analytics 4 (GA4)</h3>
                <p>
                  Über den GTM wird Google Analytics 4 eingebunden, ein Webanalysedienst der Google Ireland Limited. GA4 verwendet Cookies und ähnliche Technologien, um Seitenaufrufe, Verweildauer, Geräte- und Browserinformationen sowie ungefähre Standortdaten (auf Basis anonymisierter IP-Adressen) zu erfassen. Die IP-Anonymisierung ist standardmäßig aktiviert.
                </p>
                <p className="mt-2">
                  Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung über Cookie-Banner). Sie können Ihre Einwilligung jederzeit über die Cookie-Einstellungen im Footer widerrufen.
                </p>
                <p className="mt-2">
                  Weitere Informationen:{" "}
                  <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                    Google Datenschutzerklärung
                  </a>
                </p>

                <h3 className="mt-4 mb-2 font-semibold text-foreground">7.3 Google Ads Conversion-Tracking</h3>
                <p>
                  Wir nutzen das Conversion-Tracking von Google Ads, um die Wirksamkeit unserer Werbeanzeigen zu messen. Wenn Sie über eine Google-Anzeige auf unsere Website gelangen und eine bestimmte Aktion ausführen (z.B. Registrierung, Checkout), wird dies an Google Ads zurückgemeldet.
                </p>
                <p className="mt-2">
                  Anbieter: Google Ireland Limited (EU) / Google LLC (USA). Für die Datenübermittlung in die USA werden Standardvertragsklauseln nach Art. 46 Abs. 2 lit. c DSGVO eingesetzt.
                </p>
                <p className="mt-2">
                  Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung). Die Einwilligung kann jederzeit über die Cookie-Einstellungen im Footer widerrufen werden.
                </p>

                <h3 className="mt-4 mb-2 font-semibold text-foreground">7.4 Google Consent Mode v2</h3>
                <p>
                  Wir verwenden den Google Consent Mode v2. Dadurch wird das Verhalten von Google-Tags (Analytics, Ads) automatisch an Ihren Einwilligungsstatus angepasst. Ohne Zustimmung werden keine personenbezogenen Daten erhoben oder an Google übermittelt.
                </p>

                <h3 className="mt-4 mb-2 font-semibold text-foreground">7.5 Google Fonts</h3>
                <p>
                  Zur einheitlichen Darstellung von Schriftarten setzen wir auf unserer Website die Schriften <strong>„Plus Jakarta Sans"</strong> und <strong>„Space Grotesk"</strong> ein, die über den Dienst <strong>Google Fonts</strong> der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland („Google") bereitgestellt werden.
                </p>
                <p className="mt-2">
                  Beim Aufruf unserer Website werden die benötigten Schriftdateien direkt von den Servern von Google (fonts.googleapis.com, fonts.gstatic.com) geladen. Hierbei wird Ihre IP-Adresse sowie Informationen über den verwendeten Browser, das Betriebssystem und die aufgerufene Seite (Referrer) an Google übermittelt. Google Fonts setzt <strong>keine Cookies</strong> und führt nach unserer Kenntnis keine Profilbildung über die geladenen Schriftarten durch.
                </p>
                <p className="mt-2">
                  <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in einer einheitlichen, professionellen und barrierearmen Darstellung unserer Inhalte sowie in der Reduktion der Ladezeiten durch das global verteilte Content-Delivery-Netzwerk von Google. Die Übermittlung erfolgt bereits beim Seitenaufruf und damit vor einer möglichen Cookie-Einwilligung; eine Stützung auf Art. 6 Abs. 1 lit. a DSGVO scheidet daher aus.
                </p>
                <p className="mt-2">
                  <strong>Drittlandübermittlung:</strong> Da Google die Schriftdateien über ein weltweites Servernetz ausliefert, können personenbezogene Daten (insbesondere die IP-Adresse) auch in die USA übertragen werden. Für diese Übermittlungen werden Standardvertragsklauseln nach Art. 46 Abs. 2 lit. c DSGVO eingesetzt; ergänzend ist Google nach dem EU-US Data Privacy Framework zertifiziert.
                </p>
                <p className="mt-2">
                  Eine lokale Selbst-Hostung der Schriftarten („Self-Hosting") wird mittelfristig geprüft, um eine Drittlandübermittlung vollständig zu vermeiden. Weitere Informationen finden Sie in den Datenschutzhinweisen von Google:{" "}
                  <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                    policies.google.com/privacy
                  </a>{" "}
                  sowie in den FAQ zu Google Fonts:{" "}
                  <a href="https://developers.google.com/fonts/faq/privacy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                    developers.google.com/fonts/faq/privacy
                  </a>.
                </p>
              </div>

              {/* 8 */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">8. Cookies und Browserspeicher</h2>
                <p>Folgende Cookie-Kategorien werden verwendet:</p>
                <div className="overflow-x-auto mt-2">
                  <table className="w-full text-left text-sm border border-border">
                    <thead>
                      <tr className="bg-muted">
                        <th className="px-4 py-2 border-b border-border font-semibold text-foreground">Kategorie</th>
                        <th className="px-4 py-2 border-b border-border font-semibold text-foreground">Cookies / Speicher</th>
                        <th className="px-4 py-2 border-b border-border font-semibold text-foreground">Opt-in</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td className="px-4 py-2 border-b border-border">Notwendig</td><td className="px-4 py-2 border-b border-border">Sitzungstoken (localStorage), Cookie-Einstellungen, Sidebar-Status</td><td className="px-4 py-2 border-b border-border">Nein (immer aktiv)</td></tr>
                      <tr><td className="px-4 py-2 border-b border-border">Analyse</td><td className="px-4 py-2 border-b border-border">Google Analytics 4 (_ga, _ga_*)</td><td className="px-4 py-2 border-b border-border">Ja</td></tr>
                      <tr><td className="px-4 py-2 border-b border-border">Marketing</td><td className="px-4 py-2 border-b border-border">Google Ads Conversion (_gcl_*)</td><td className="px-4 py-2 border-b border-border">Ja</td></tr>
                      <tr><td className="px-4 py-2">Betrugsschutz</td><td className="px-4 py-2">Stripe Fraud-Detection (im Zahlungsvorgang)</td><td className="px-4 py-2">Nein (berechtigtes Interesse)</td></tr>
                    </tbody>
                  </table>
                </div>
                <p className="mt-2">Rechtsgrundlage für notwendige Cookies: Art. 6 Abs. 1 lit. b/f DSGVO. Für Analyse-/Marketing-Cookies: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).</p>
              </div>

              {/* 9 */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">9. E-Mail-Kommunikation</h2>
                <p>Wir sind unter folgenden E-Mail-Adressen erreichbar:</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li><strong>info@nxtinvoice.de</strong> – allgemeine Anfragen</li>
                  <li><strong>support@nxtinvoice.de</strong> – Kundensupport</li>
                  <li><strong>legal@nxtinvoice.de / legal@lizenzwerk24.de</strong> – rechtliche und datenschutzrechtliche Anfragen</li>
                </ul>
                <p className="mt-2">
                  Bei E-Mail-Kontakt werden die übermittelten Daten (Absenderadresse, Nachrichteninhalt) ausschließlich zur Bearbeitung der Anfrage verwendet.
                </p>
                <p className="mt-2">Folgende transaktionale E-Mails werden automatisch versendet:</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>E-Mail-Verifizierung bei Registrierung</li>
                  <li>Passwort-Reset-Links</li>
                  <li>Sicherheitsrelevante Kontobenachrichtigungen</li>
                </ul>
                <p className="mt-2">Rechtsgrundlage: Art. 6 Abs. 1 lit. b, f oder c DSGVO je nach Anfrageinhalt.</p>
                <p className="mt-2">
                  Ein Newsletter wird derzeit nicht versandt. Sollte dies eingeführt werden, erfolgt dies auf Basis einer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) im Double-Opt-In-Verfahren.
                </p>
              </div>

              {/* 10 */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">10. Drittlandübermittlungen</h2>
                <p>
                  Im Zusammenhang mit Stripe, Google (Analytics/Ads) und der Lovable-/Supabase-Infrastruktur können personenbezogene Daten in die USA übermittelt werden. In diesen Fällen erfolgt die Übermittlung auf Basis von Standardvertragsklauseln (Art. 46 Abs. 2 lit. c DSGVO), ergänzt durch technische und organisatorische Schutzmaßnahmen.
                </p>
              </div>

              {/* 11 */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">11. Speicherdauer</h2>
                <div className="overflow-x-auto mt-2">
                  <table className="w-full text-left text-sm border border-border">
                    <thead>
                      <tr className="bg-muted">
                        <th className="px-4 py-2 border-b border-border font-semibold text-foreground">Datenkategorie</th>
                        <th className="px-4 py-2 border-b border-border font-semibold text-foreground">Speicherdauer</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td className="px-4 py-2 border-b border-border">Konto- und Profildaten</td><td className="px-4 py-2 border-b border-border">Bis zur Kontolöschung</td></tr>
                      <tr><td className="px-4 py-2 border-b border-border">Rechnungs- und Vertragsdaten</td><td className="px-4 py-2 border-b border-border">10 Jahre (§ 147 AO, § 257 HGB)</td></tr>
                      <tr><td className="px-4 py-2 border-b border-border">Technische Protokolldaten</td><td className="px-4 py-2 border-b border-border">Nur für die Dauer der technischen Notwendigkeit</td></tr>
                      <tr><td className="px-4 py-2">Zahlungsdaten (bei Stripe)</td><td className="px-4 py-2">Gemäß Stripe Data Retention Policy</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* 12 */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">12. Auftragsverarbeitung</h2>
                <p>Folgende Dienstleister werden als Auftragsverarbeiter nach Art. 28 DSGVO eingesetzt:</p>
                <div className="overflow-x-auto mt-2">
                  <table className="w-full text-left text-sm border border-border">
                    <thead>
                      <tr className="bg-muted">
                        <th className="px-4 py-2 border-b border-border font-semibold text-foreground">Dienstleister</th>
                        <th className="px-4 py-2 border-b border-border font-semibold text-foreground">Funktion</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td className="px-4 py-2 border-b border-border">Lovable Technology Ltd.</td><td className="px-4 py-2 border-b border-border">Website-Hosting, Cloud-Infrastruktur</td></tr>
                      <tr><td className="px-4 py-2 border-b border-border">Supabase Inc.</td><td className="px-4 py-2 border-b border-border">Datenbank und Authentifizierung (Sub-Auftragsverarbeiter via Lovable)</td></tr>
                      <tr><td className="px-4 py-2 border-b border-border">Stripe Payments Europe Ltd. / Stripe Inc.</td><td className="px-4 py-2 border-b border-border">Zahlungsabwicklung</td></tr>
                      <tr><td className="px-4 py-2 border-b border-border">STRATO AG</td><td className="px-4 py-2 border-b border-border">Domain- und E-Mail-Hosting</td></tr>
                      <tr><td className="px-4 py-2">Google Ireland Limited</td><td className="px-4 py-2">Webanalyse (GA4), Ads Conversion-Tracking, Tag Manager</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* 13 */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">13. Automatisierte Entscheidungsfindung</h2>
                <p>Es findet keine automatisierte Entscheidungsfindung einschließlich Profiling im Sinne von Art. 22 DSGVO statt.</p>
              </div>

              {/* 14 */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">14. Rechte der betroffenen Personen</h2>
                <p>Betroffene Personen haben folgende Rechte:</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li><strong>Auskunft</strong> über gespeicherte Daten (Art. 15 DSGVO)</li>
                  <li><strong>Berichtigung</strong> unrichtiger Daten (Art. 16 DSGVO)</li>
                  <li><strong>Löschung</strong> der Daten (Art. 17 DSGVO)</li>
                  <li><strong>Einschränkung</strong> der Verarbeitung (Art. 18 DSGVO)</li>
                  <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
                  <li><strong>Widerspruch</strong> gegen bestimmte Verarbeitungen (Art. 21 DSGVO)</li>
                  <li><strong>Widerruf</strong> erteilter Einwilligungen mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO)</li>
                </ul>
                <p className="mt-2">
                  Zur Ausübung dieser Rechte genügt eine formlose Mitteilung an{" "}
                  <a href="mailto:legal@nxtinvoice.de" className="text-primary hover:underline">legal@nxtinvoice.de</a>.
                </p>
                <p className="mt-2">
                  Zudem besteht ein Beschwerderecht bei der zuständigen Datenschutzaufsichtsbehörde (Art. 77 DSGVO):
                </p>
                <p className="mt-2">
                  <strong>Sächsische Datenschutz- und Transparenzbeauftragte</strong><br />
                  Maternistraße 17, 01067 Dresden<br />
                  Telefon: +49 351 85471-101<br />
                  E-Mail: <a href="mailto:post@sdtb.sachsen.de" className="text-primary hover:underline">post@sdtb.sachsen.de</a>
                </p>
              </div>

              {/* 15 */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">15. Datensicherheit</h2>
                <p>Die Website wird ausschließlich über HTTPS bereitgestellt. Alle Datenübertragungen sind durch SSL-/TLS-Verschlüsselung gesichert.</p>
              </div>

              {/* 16 */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">16. Minderjährigenschutz</h2>
                <p>
                  nxtinvoice.de richtet sich ausschließlich an gewerbliche Nutzer (B2B). Das Angebot ist nicht für Personen unter 18 Jahren bestimmt. Werden uns Daten einer minderjährigen Person bekannt, werden diese unverzüglich gelöscht.
                </p>
              </div>

              {/* 17 */}
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">17. Änderungen dieser Datenschutzerklärung</h2>
                <p>
                  Diese Datenschutzerklärung wird bei Bedarf aktualisiert. Es gilt jeweils die auf der Website veröffentlichte Fassung mit dem aktuellen Datumsstand.
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default Privacy;
